import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-dropdown-menu-component', (editor, opts = {}) => {
  const config = {
    blocks: [
      'dropdownMenu',
    ],
    name: 'dropdownMenu',
    stylePrefix: 'gjs-',
    label: 'Menu Desplegable',
    defText: 'Sample',
    category: 'Otros',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
